import { Navigate, type RouteObject } from "react-router-dom";
import { useLocale } from "@admin/app/locale";
import { useSessionQuery } from "@/shared/services/useSessionQuery";
import { ADMIN_ROLES } from "@/lib/auth/admin-roles";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { LoadingState } from "@/shared/rd";
import { NavigationGuardProvider } from "@/lib/navigation/navigationGuard";
import { WhatsappPage } from "./pages/WhatsappPage";
function WhatsappRoute() {
  const locale = useLocale();
  const t = useTranslations();
  const session = useSessionQuery();
  if (session.isLoading)
    return <LoadingState title={t(keys.shell.loadingTitle, { page: t(keys.whatsapp.nav) })} sub={t(keys.shell.loadingSub)} rows={0} />;
  if (!session.data?.admin?.roles?.includes(ADMIN_ROLES.SUPER_ADMIN))
    return <Navigate to={`/${locale}/admin`} replace />;
  return (
    <NavigationGuardProvider>
      <WhatsappPage />
    </NavigationGuardProvider>
  );
}
export const whatsappRoutes: RouteObject[] = [
  { path: "whatsapp", element: <WhatsappRoute /> },
];
